{
  "mix": {
    "select_an_option": "Select an option",
    "yes": "yes",
    "no": "no",
    "login": "login",
    "logout": "logout",
    "back": "back",
    "back_to_seasons": "Back to Seasons",
    "none": "None",
    "next": "Next",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy",
    "and": "and",
    "skip": "Skip",
    "close": "Close",
    "cancel": "Cancel",
    "distance": "Distance",
    "religions": "Religions",
    "denominations": "Denominations",
    "causes": "Causes",
    "reviews": "Reviews",
    "light_rating": "Light Rating",
    "learn_more": "Learn more",
    "contact_us": "Contact us",
    "fair": "Fair",
    "focus_area": "Focus Area Interests",
    "no_result": "No results found",
    "no_address_match": "No addresses match?",
    "submit": "Submit",
    "n_a": "Not Available",
    "sign_up": "Sign up",
    "details": "Details",
    "apply": "Apply",
    "select_date": "Select date",
    "continue": "Continue",
    "set_up_later": "Set up later",
    "camera": "Camera",
    "gallery": "Gallery",
    "choose_from": "Choose from",
    "main": "Main",
    "done": "Done",
    "no_options": "No options",
    "edit_title": "Edit",
    "map": "Map",
    "error_loading_map": "Error loading map",
    "month": "Month",
    "year": "Year",
    "all_time": "All Time",
    "custom": "Custom",
    "download_history": "Download Transactions Report",
    "download_pdf": "Download PDF",
    "download_csv": "Download CSV",
    "csv_email_disclaimer": "The CSV file will be sent to your registered email address.",
    "save": "Save",
    "update": "Update",
    "file_uploaded": "File uploaded!",
    "tap_to_upload": "Tap to Upload",
    "browse_files": "Browse Files",
    "edited": "Edited",
    "results": "Results",
    "phone": "Phone",
    "email": "Email",
    "message": "Message",
    "browse": "Browse",
    "search": "Search",
    "delete_warning": "Are you sure you want to procced?",
    "delete": "Delete",
    "claim": "Claim",
    "password": "Password",
    "large_process_wait": "We are processing your data, this may take a while...",
    "positive_number": "Can't be a negative value",
    "credit_cards": "Credit Cards",
    "contact_us_support": "Contact us for support",
    "uploading": "Uploading files...",
    "terms_of_service": "Terms of Service",
    "terms_of_services": "Terms of Services",
    "confirm": "Confirm",
    "valid_email": "Enter a valid email",
    "match_email": "Emails must match",
    "required_email": "Email Address is required",
    "required_email_confirmation": "Required Email Confirmation",
    "no_plus_allowed": "Email addresses with '+' are not allowed for billing",
    "city_required": "City is required",
    "enter_valid_address": "Please enter a valid address",
    "max_length": "Max length %{LENGTH} characters",
    "exact_length": "Must be exactly %{LENGTH} digits long",
    "min_length": "Min length %{LENGTH} characters",
    "not_repeating_digits": "Must not have repeating digits",
    "must_be_number": "Must be a number",
    "must_be_positive": "Must be positive",
    "err_size_img": "Error uploading image",
    "err_size_img_cropped": "Image file size must be between 500 KB and 30 MB and the result of your cropped image is %{FILE_SIZE} MB",
    "err_size_img_msg": "Image file size must be between 500 KB and 30 MB",
    "err_getting_file_size": "Error getting file size",
    "err_taking_img": "Error taking picture!",
    "err_crop_further_title": "Cannot Crop Image Further",
    "err_crop_further_msg": "This image cannot be cropped beyond the minimum allowed size. Please adjust your selection.",
    "crop_img_modal_title": "Crop Image",
    "drag_drop_image_text": "Drag & drop images here, or click to select",
    "add_more_images": "+ Add Images",
    "phone_required": "Phone Number is required",
    "valid_phone_number": "Valid phone number required",
    "validating": "Validating",
    "reason_required": "Reason is required",
    "securing_session": "Securing your session, please wait...",
    "err_size_file_title": "File size must be less than %{MAX_FILE_SIZE} MB",
    "err_size_file": "File size must be less than %{MAX_FILE_SIZE} MB and your file size is %{FILE_SIZE} MB",
    "submit_again": "Submit Again",
    "date": "Date",
    "change": "Change",
    "message_required": "Message is required",
    "show_title": "The Religion Business",
    "go_back": "Go Back",
    "share": "Share",
    "cant_find_address": "Can't find your address?",
    "enter_manually": "Enter it manually",
    "back_to_suggestions": "← Back to suggestions",
    "gift": "Gift Series",
    "copy_url": "Copy URL",
    "recaptcha_helper": "Please complete the security check to continue.",
    "copied": {
      "title": "Copied!",
      "message": "Text has been copied to clipboard.",
      "link": "Link has been copied to clipboard"
    },
    "mail_not_openned": {
      "title": "Oops! Something went wrong while opening your email app.",
      "message": "It looks like Mail isn't available on this device."
    },
    "sharing_not_available": "Sharing is not available on this device",
    "failed_download_qr": "Failed to download QR code",
    "text_user": "Text User",
    "sms_not_supported": "📭 SMS sending not supported on this platform.",
    "direct_message": "Direct Message",
    "volunteer_event": "Volunteer Event",
    "delete_msg_error": "You don't have permission to delete messages from other users.",
    "ai_search": {
      "status_thinking": "Thinking...",
      "status_analyzing": "Analyzing criteria...",
      "status_fetching": "Fetching results...",
      "no_results": "No results found",
      "refine_search": "Refine Search Terms",
      "default_label": "Try AI Powered Search",
      "default_sub_label": "Trouble finding your non profit?"
    }
  },
  "header": {
    "bs": "Broken Shepherds™",
    "b": "Broken",
    "s": "Shepherds™"
  },
  "bottom_tab": {
    "home": "Home",
    "donation": "Donate",
    "engage": "Engage",
    "impact": "Impact",
    "profile": "Profile",
    "transactions": "Transactions"
  },
  "home": {
    "npos": "Non-Profit Orgs",
    "missions": "Missions",
    "empty_missions": "No missions to show",
    "empty_participants": "No participants to show",
    "charities": "Charities",
    "empty_charities": "No charities to show",
    "churches": "Churches",
    "empty_churches": "No churches to show",
    "search_placeholder": "Search location, or non profit name",
    "filters": {
      "title": "Filters",
      "show_results": "Show results",
      "sort_light_rating": "Sort Light Rating",
      "distance_subtitle": "%{MINIMUM_DISTANCE}-%{MAXIMUM_DISTANCE} miles",
      "rating_subtitle": "Choose minimum rating",
      "reset_filters": "Reset filters",
      "enable_distance": "Enable distance filter",
      "htl": "High to low",
      "lth": "Low to high"
    }
  },
  "engage": {
    "volunteer": "Volunteer",
    "trending": "Trending",
    "empty_trending": "Coming soon"
  },
  "profile": {
    "start_receiving_donations": "Receive Donations",
    "generate_profile_qr": "Profile QR Code",
    "generate_donation_profile_qr": "Generate donation profile QR code",
    "download_qr": "Download QR Code",
    "need_documents": "Pending Documentation!",
    "merchant_created_account": "Account Active",
    "go_to_documents": "Go To Pending Documentation",
    "need_documents_message": "Your account is active and has been able to accept donations, however, to release funds to your bank account, you must submit the required documents for review within 48 hours from account creation. After submission, the underwriting team will review your documents.",
    "saved_continue_title": "You're All Set for Now",
    "saved_continue_description": "Your progress has been saved. You can continue onboarding anytime from your profile.",
    "add_question": "Add Q and A",
    "profile_complete_progress": "Your profile is %{PROGRESS_PERCENT}% complete.",
    "finish_setup": "Finish profile setup",
    "create_program": "Create Program",
    "create_event": "Create Volunteer Event",
    "create_amenity": "Add Amenity",
    "volunteer_form": {
      "name_required": "Name is required",
      "location_required": "Location is required",
      "address_required": "Address is required",
      "description_required": "Description is required",
      "start_date_required": "Date is required",
      "subtitle_required": "Title is required",
      "thumbnail_required": "Enter at least the Main image"
    },
    "create_form": {
      "name_label": "Name of Volunteer Event",
      "name_placeholder": "Enter name",
      "title_label": "Title",
      "title_placeholder": "Enter title",
      "description_label": "Description",
      "description_placeholder": "Enter description",
      "address_label": "Address",
      "address_placeholder": "Enter Address",
      "images_label": "Add Volunteer Event Images",
      "date_label": "Choose date and time",
      "budget_label": "Annual Budget",
      "location_label": "Location",
      "location_placeholder": "Add location address (optional)",
      "event_success_message": "Volunteer Event created successfully",
      "event_image_required_title": "Image Required",
      "event_image_required_message": "At least the main image is required",
      "event_edit_success_message": "Volunteer Event edited successfully",
      "program_success_message": "Program created successfully",
      "amenities_add_another": "Add another Amenity",
      "amenities_success_message": "Amenities created successfully",
      "submit_add_amenity": "Submit and add another Amenity",
      "validations": {
        "name_required": "Name is required",
        "min_amenities_to_submit": "Is neccessary to have at least 1 amenity to submit"
      }
    },
    "impact": {
      "impacts": "IMPACTS",
      "charities": "CHARITIES",
      "churches": "CHURCHES",
      "total_donated": "Total Donated",
      "total_donation_amount": "Your total donation amount",
      "empty_donations": "No impacts to show",
      "total_allTime_impact": "Total all-time"
    },
    "notifications": {
      "title": "Notifications",
      "empty_notifications": "No notifications to show"
    },
    "edit_profile": "Edit Profile",
    "update_profile_success_message": "Profile updated successfully",
    "update_profile_failure_message": "Error occurred while updating the profile",
    "your_profile": "Your Profile",
    "go_settings": "Go to your Settings",
    "no_npo_yet": "You don't have a Npo yet..."
  },
  "settings": {
    "title": "Settings",
    "screen_names": {
      "your_preferences": "Your preferences",
      "mileage_radius": "Mileage radius",
      "edit_name": "Edit name",
      "change_password": "Change password",
      "favorites": "Favorites",
      "payment_methods": "Saved Payment Methods",
      "transactions": "Transactions",
      "subscriptions": "Subscriptions",
      "privacy_policy": "Privacy Policy",
      "merchant_documents": "Payment Documents",
      "share_npo": "Share QR Code",
      "terms_conditions": "Terms and Conditions",
      "faq": "FAQ",
      "contact": "Contact Broken Shepherds™",
      "show_title": "The Religion Business",
      "gifts_title": "Gifted Shows",
      "logout": "Log out",
      "delete_account": "Delete account"
    },
    "preferences": {
      "title": "Preferences",
      "failure_loading_mypreferences": "Error loading preferences. Please try again later.",
      "success_message": "Preferences updated successfully",
      "failure_message": "Error updating preferences"
    },
    "mileage_radius": {
      "title": "Mileage Radius",
      "success_message": "Mileage radius updated successfully!",
      "failure_message": "Error updating Mileage radius"
    },
    "edit_name": {
      "title": "Name",
      "advice": "You can change your name one time per year.",
      "name_required": "Name is required",
      "lastname_required": "Lastname is required",
      "name_placeholder": "Enter name",
      "lastname_placeholder": "Enter lastname",
      "success_message": "Name and lastname updated successfully!",
      "failure_message": "Error updating name and lastname"
    },
    "change_password": {
      "current_password_missing": "Current password is missing",
      "new_password_required": "New password is required",
      "passwords_must_match": "Passwords must match",
      "confirmation_required": "Password confirmation is required",
      "validations_title": "Password must contain the following",
      "error_min_characters": "Password should be of minimum 8 characters length",
      "error_min_numbers": "Password must include at least one number",
      "error_min_special_characters": "Password must include one special character",
      "min_characters": "At least 8 characters",
      "min_numbers": "Include 1 number",
      "min_lowercase": "Must contain at least one lowercase",
      "min_uppercase": "Must contain at least one uppercase",
      "success_message": "Password updated successfully!",
      "failure_message": "Error updating password",
      "failure_reauthentication_message": "The current password is incorrect or something went wrong",
      "current_password_placeholder": "Current Password",
      "new_password_placeholder": "New Password",
      "confirmation_placeholder": "Re-Type Password"
    },
    "logout": {
      "title": "Are you sure you want to log out?"
    },
    "delete_account": {
      "title": "Are you sure you want to delete your account?",
      "message": "Once you delete your profile, all your saved information will be gone.",
      "action": "Delete account"
    },
    "share_qr": {
      "title": "Create a QR Code",
      "message": "Do you want to create a QR code for your organization? It will be sent to your registered email address, and you can also view it right now.",
      "action": "Create QR Code",
      "success_title": "QR Code Created Successfully!",
      "success_message": "We've sent the QR code to your registered email address!"
    },
    "transactions": {
      "empty": "No transactions made yet",
      "contacted_npo": "You contacted %{NPO_NAME} succesfully!"
    }
  },
  "npo_details": {
    "update_message": "Information updated!",
    "insights": {
      "revenue": "Gross Revenue",
      "totalSalaries": "Total Salaries",
      "fundRaising": "Fundraising & Marketing",
      "landEquipments": "Land, Building & Equipments",
      "allocation": "Expense Allocations",
      "allowance": "Allowance",
      "salaries": "Top Salaries",
      "board": "Board of Directors",
      "checks": "Background Checks",
      "employees": "Employees",
      "volunteers": "Volunteers",
      "pl": "Profit/Loss Statement",
      "balanceSheet": "Balance Sheet",
      "nineNinetyForm": "IRS Form 990",
      "nineNinetyForm_button": "View form",
      "thirdPartyAudit": "Annual 3rd party audit",
      "impactStudy": "Impact Study",
      "pl_button": "View P & L",
      "balanceSheet_button": "View Balance Sheet",
      "thirdPartyAudit_button": "View 3rd party audit",
      "impactStudy_button": "View Impact Study",
      "programs": "Programs",
      "byLaws": "By-Laws",
      "bylaws_button": "View By-Laws",
      "amenities": "Amenities",
      "all_amenities": "View all 10 Amenities",
      "qa_button_edit": "Add Q and A",
      "qa_button": "Ask a Question",
      "qa_all_button": "View Questions",
      "map": "Where you will be"
    }
  },
  "messages": {
    "title": "Messages",
    "search_message_placeholder": "Search messages",
    "send_message_placeholder": "Send message",
    "edit_message_placeholder": "Edit Message",
    "respond_message_placeholder": "Send Direct Message",
    "no_messages": "No messages yet...",
    "private_chat": "Private Chat"
  },
  "light_rating_bottom_sheet": {
    "footer": "Our Light Rating is a proprietary standardized formula that brings transparency into the non-profit sector. The calculation is based off data and documents provided by each non-profit organization. Broken Shepherds™ takes an unbiased stance regarding data provided."
  },
  "light_rating_explanation": {
    "description": "Our Light Rating is a proprietary standardized formula that brings transparency into the non-profit sector. The calculation is based on data and documents provided by each non-profit organization. Broken Shepherds™ takes an unbiased stance regarding data provided.",
    "subtitle": "Here are the important factors that curate the Light Rating.",
    "additional_questions": "Additional questions or issue with your rating?"
  },
  "npo_tab": {
    "insights": "Insights",
    "programs": "Programs",
    "volunteer": "Volunteer",
    "empty_programs": "No programs to show",
    "empty_volunteer": "No volunteer events to show"
  },
  "sign_in": {
    "login": {
      "errorTitle": {
        "invalidPhoneNumber": "Invalid Phone Number",
        "missingPhoneNumber": "Phone Number Missing",
        "quotaExceeded": "Too Many Requests",
        "userDisabled": "Account Disabled",
        "operationNotAllowed": "Sign-In Not Allowed",
        "invalidVerificationCode": "Invalid Code",
        "codeExpired": "Code Expired",
        "missingVerificationCode": "Missing Code",
        "invalidVerificationId": "Verification Error",
        "invalidEmail": "Invalid Email",
        "missingEmail": "Email Required",
        "userNotFound": "User Not Found",
        "invalidCredential": "Invalid Credentials",
        "missingPassword": "Password Required",
        "tooManyRequests": "Too Many Attempts",
        "generic": "Authentication Error"
      },
      "errorMessage": {
        "invalidPhoneNumber": "The phone number format is incorrect. Please enter a valid number with the country code.",
        "missingPhoneNumber": "Please enter your phone number to continue.",
        "quotaExceeded": "SMS quota has been exceeded for this project. Please try again later.",
        "userDisabled": "Your account has been disabled. Please contact support for assistance.",
        "operationNotAllowed": "Phone number sign-in is currently disabled. Please contact support.",
        "invalidVerificationCode": "The verification code you entered is incorrect. Please try again.",
        "codeExpired": "The verification code has expired. Please request a new one.",
        "missingVerificationCode": "Please enter the verification code sent to your phone.",
        "invalidVerificationId": "There was a problem verifying your code. Please try again.",
        "invalidEmail": "The email address is not properly formatted.",
        "missingEmail": "Please enter your email address.",
        "userNotFound": "No user found with this email address.",
        "invalidCredential": "The email or password you entered is incorrect.",
        "missingPassword": "Please enter your password.",
        "tooManyRequests": "Too many login attempts. Please try again later.",
        "generic": "Something went wrong. Please try again."
      }
    },
    "onboarding": {
      "self": "Onboarding",
      "subtitle": "Welcome, what are you here for?",
      "npo_title": "Non-profit Org",
      "npo_description": "Religious and Secular",
      "individual_title": "Individual",
      "browse_title": "Browse Only"
    },
    "eula": {
      "title": "Eula",
      "first_terms": "By using the Broken Shepherds™ app, you agree to follow our"
    },
    "individual": {
      "phone_sign_in": {
        "title": "Let's get you signed in",
        "button": "Send Verification Text",
        "sms": "Standard SMS rates will apply.",
        "first_terms": "By continuing, you agree to our",
        "second_terms": ". You must be 13 years old or older to sign up.",
        "placeholder": "Enter phone number"
      },
      "interests": {
        "title": "Choose interests",
        "description": "Set your personal preferences to customize your experience. These will align you with non-profit organizations within your areas of interest. They can later be changed in your Settings under Your Preferences.",
        "denominations": "Denominations",
        "religions": "Religions",
        "focus_area": "Focus Area Interests",
        "focus_area_description": "Select up to 5 interests."
      },
      "distances": {
        "title": "Choose distance and location",
        "description": "Set your distance to display organizations and events near you.",
        "placeholder": "Type city or zip code , then pick one from the list",
        "range": "%{MINIMUM_DISTANCE}-%{MAXIMUM_DISTANCE} miles"
      },
      "profile": {
        "title": "Create your profile",
        "name_placeholder": "First name",
        "last_placeholder": "Last name",
        "validation": "Must enter first name and last name"
      },
      "verify": {
        "title": "Verify your number",
        "button": "Resend Code",
        "message": "Verification code sent to",
        "title_success": "Code Sent",
        "title_error": "Invalid code",
        "message_error": "Please try again",
        "sms_error": "Failed to send SMS"
      }
    },
    "nonProfit": {
      "save_continue": "Save and continue later",
      "go_to_profile": "Go To Your Profile",
      "enter_dollar_amount": "Enter dollar amount",
      "login": {
        "title": "Sign in to your Non-Profit Organization",
        "to_have_login_as_npo": "To have a login as a non-profit organization, you must be verified.",
        "claim_npo": "Claim a non-profit Org",
        "failed_login": "Failed to login"
      },
      "forgot_password": {
        "title": "Enter your email address to receive a reset password email.",
        "success_message": "Email sent, please check your email inbox...",
        "failure_message": "Error sending email",
        "forgot_password": "Forgot password"
      },
      "preferences": {
        "title": "Choose Preferences",
        "description": "These choices do not affect your Light Rating. They can later be changed in your Settings under Your Preferences.",
        "info": "Select focus areas you work in",
        "denominations": "Denominations",
        "religions": "Religions",
        "programs": "Program Interests"
      },
      "intro": {
        "title": "Welcome, let's finish setting up your profile.",
        "subtitle": "Completing your profile is essential for your non-profit organization. It helps you build credibility and connect with people interested in your mission and impact. This information curates your Light Rating.",
        "start": "Let's get started!",
        "start_profile": {
          "subtitle": "Revolutionize how the world sees you with a custom profile on Broken Shepherds™. This information will be visible to users exploring your organization. The more requested data and information you provide, the higher your Light Rating.",
          "create_profile": "Public Profile Setup",
          "start_profile_setup": "Let's get started!",
          "what_you_will_need": "Documents requested to complete your profile:",
          "list": {
            "form990": "IRS Form 990 document (for secular orgs only)",
            "organizationImages": "Marketing images (at least 1 image required, max 5 images total, between 500 KB and 30 MB each)",
            "financialStatement": "Profit & Loss Statement and Balance Sheet documents",
            "thirdPartyAudit": "3rd Party Audit document (if available)",
            "impactStudy": "Impact Study document (if available)",
            "churchBylaws": "Bylaws document (for religious orgs only)"
          },
          "files": "Only PDF for documents and JPG or PNG for images are accepted."
        }
      },
      "general": {
        "general_section": "Public Non-Profit Information",
        "general_section_description": "Tell us about your non-profit to help connect you with supporters.",
        "name_section": "Non-Profit Name",
        "name_section_description": "Enter the name your organization is commonly known by (DBA) to help users recognize it.",
        "name_placeholder": "Enter your non-profit name",
        "description_section": "Description",
        "description_section_description": "Add a short description of your non-profit. You can use your mission statement, website copy, or a brief overview—whatever best represents your organization.",
        "description_placeholder": "Enter a description",
        "email_section": "Email Address",
        "email_section_description": "Provide a valid email address to receive notifications about donations, volunteer sign-ups, and important account activity.",
        "email_placeholder": "Enter email address",
        "address_section": "Address of Organization",
        "address_section_description": "Enter your non-profit's physical mailing address. P.O. boxes are not accepted.",
        "address_placeholder": "Enter address of organization",
        "show_map_label": "Check box to have a map show location on your profile",
        "total_employees_section": "Number of Employees",
        "total_employees_section_description": "Enter the total number of employees at your organization.",
        "total_employees_placeholder": "Enter number of employees",
        "total_volunteers_section": "Estimated Number of Volunteers",
        "total_volunteers_section_description": "Provide an estimate of how many volunteers support your organization.",
        "total_volunteers_placeholder": "Enter number of volunteers",
        "thumbnail_section": "Add Organization Images",
        "thumbnail_section_description": "Upload up to 5 images that showcase your non-profit's work, events, or team. Visuals help tell your story and engage supporters. Minimum 1 image is required. Main profile image should be clean with no copy or logos.",
        "optimal_image_size": "Upload images: Only image files (JPG, PNG) are accepted. Size must be between 500 KB and 30 MB. Square images are recommended."
      },
      "nine_ninty": {
        "upload_form": "Upload Form 990",
        "upload_form_info": "Form 990 is an annual information return that tax-exempt organizations file with the IRS. It provides details about the organization's mission, programs, finances, and governance.",
        "recommendation": "This document is used to help prefill key fields and streamline the onboarding process. To ensure accurate data processing, we recommend uploading a high-quality file without watermarks. This helps avoid errors during automated document reading.",
        "newOrgCheck_label": "Is this a newly formed organization? If so, you may skip uploading the IRS Form 990."
      },
      "revenue": {
        "total_revenue": "Total Annual Revenue",
        "total_revenue_description": "Enter your non-profit's total annual revenue dollar amount.",
        "total_expenses": "Total Annual Expenses",
        "total_expenses_description": "Enter your non-profit's total annual expenses dollar amount."
      },
      "background_checks": {
        "title": "Does Your Organization Do Background Checks?",
        "description": "Indicate whether or not your organization conducts background checks for employees and/or volunteers.",
        "employees": "Employees",
        "volunteers": "Volunteers"
      },
      "board_directors": {
        "title": "Board of Directors",
        "description": "Provide details of your current board of directors.",
        "individual_title": "Director",
        "add_title": "Add Board of Director",
        "position_label": "Title",
        "position_sublabel": "Enter board member's official title (e.g., Chair, Treasurer, Secretary, Director, Board Member).",
        "position_placeholder": "Enter title",
        "fullName_label": "Name",
        "fullName_sublabel": "Enter the full name of the board member as it appears in official records.",
        "fullName_placeholder": "Enter name",
        "annualSalary_label": "Annual Salary",
        "annualSalary_sublabel": "Enter the board member's annual salary, if applicable. If the position is unpaid, you may enter 0.",
        "annualSalary_placeholder": "Enter annual salary",
        "allowance_label": "Stipend",
        "allowance_placeholder": "Enter dollar amount",
        "add_another": "Add another Director",
        "submit_add_another": "Submit and add another Director"
      },
      "pastors": {
        "title": "Pastors",
        "description": "Provide details of your current pastors.",
        "individual_title": "Pastor",
        "add_title": "Add Pastor",
        "position_label": "Title",
        "position_sublabel": "Enter pastor's official title (e.g., Pastor, Pastoress, Elder, Bishop, Archbishop).",
        "position_placeholder": "Enter title",
        "fullName_label": "Name",
        "fullName_sublabel": "Enter the full name of the pastor as it appears in official records.",
        "fullName_placeholder": "Enter name",
        "annualSalary_label": "Annual Salary",
        "annualSalary_sublabel": "Enter the pastor's annual salary, if applicable. If the position is unpaid, you may enter 0.",
        "annualSalary_placeholder": "Enter annual salary",
        "allowance_label": "Stipend",
        "allowance_placeholder": "Enter dollar amount",
        "add_another": "Add another Pastor",
        "submit_add_another": "Submit and add another Pastor"
      },
      "total_salaries": {
        "salaries_section": "Total Annual Salaries",
        "salaries_section_description": "Enter the total annual salary expenses for your organization. This includes all paid staff and leadership compensation.",
        "salaries_placeholder": "Enter total annual salaries",
        "benefits_section": "Total Other Annual Employee Benefits",
        "benefits_section_description": "Enter the total annual dollar amount spent on employee benefits (e.g., health insurance, retirement plans, stipends) outside of salaries.",
        "benefits_placeholder": "Enter total annual employee benefits"
      },
      "pl": {
        "pl_section": "Upload P & L statement",
        "pl_section_description": "Upload your organization's Profit & Loss statement (P&L).",
        "balance_sheet_section": "Upload Balance Sheet",
        "balance_sheet_section_description": "Upload your organization's Balance Sheet."
      },
      "party_audit": {
        "title": "Does Your Organization Conduct Third-Party Audits or CPA Reviews?",
        "description": "If so, upload your organization's most recent third-party audit report or CPA review.",
        "info": "A third-party audit is an independent financial review conducted by an external certified public accountant (CPA) to assess the accuracy of your organization's financial statements and practices. A CPA review is a limited financial examination conducted by an independent certified public accountant. It provides moderate assurance that your financial statements are free of material misstatements, without the depth of a full audit."
      },
      "impact_study": {
        "title": "Has an Impact Study Been Conducted on Your organization?",
        "description": "If so, upload your organization's most recent impact study.",
        "info": "An impact study is a report or evaluation that measures the outcomes of your organization's programs or services. It helps show the effectiveness and real-world results of your work."
      },
      "salaries": {
        "title": "Salary",
        "salaries_section": "Annual Individual Salaries",
        "add_title": "Add Salary",
        "enter_at_least": "Requirement: Provide salary information for organization's top 10% wage earners, capped at 10 individuals.",
        "add_another": "Add another Salary",
        "date_label": "Choose date and time (optional)",
        "name_label": "Name",
        "name_sublabel": "Enter the full name of the individual as it appears on official records.",
        "name_placeholder": "Enter Name",
        "job_label": "Job Title",
        "job_sublabel": "Enter the job title for this role.",
        "job_placeholder": "Enter job title",
        "salary_label": "Annual Salary",
        "salary_sublabel": "Enter the individual's annual salary.",
        "salary_placeholder": "Enter annual salary",
        "allowance_label": "Monthly Housing Allowance",
        "allowance_sublabel": "Monthly Housing Allowance",
        "allowance_placeholder": "Enter dollar amount",
        "submit_and_add": "Submit and add another Salary"
      },
      "land_equipments": {
        "title": "Annual Cost for Land, Buildings and Equipment",
        "description": "Enter the total value of your organization's land, buildings, and equipment. This reflects your tangible assets.",
        "placeholder": "Enter annual cost for land, buildings and equipment"
      },
      "fundraising": {
        "title": "Annual Cost for Fundraising and Marketing",
        "description": "Enter your organization's total annual expenses for fundraising and marketing activities.",
        "placeholder": "Enter annual cost for fundraising and marketing"
      },
      "programs": {
        "title": "Programs",
        "individual_title": "Program",
        "add_title": "Add Program",
        "info": "List all programs, services, or initiatives offered. Program description should include a detailed overview of the program, outlining its objectives, target audiences, and key features. You should explain the program's purpose, its intended outcomes, and how it fits within the organization's broader mission. Annual cost for program should include all financial expenses associated with running the program, such as fees, materials, supplies, accommodations, etc",
        "add_another": "Add another Program",
        "date_label": "Choose date and time (optional)",
        "name_label": "Name of Program",
        "name_placeholder": "Enter name of Program",
        "description_label": "Program Description",
        "description_sublabel": "Provide a brief overview of the program's purpose, activities, and impact. This helps others understand its goals and benefits.",
        "description_placeholder": "Enter program description",
        "budget_label": "Annual budget",
        "budget_placeholder": "Add annual budget",
        "location_placeholder": "Add location address (optional)",
        "submit_and_add": "Submit and add another Program",
        "upload_form": "Upload By-Laws"
      },
      "total_grants_programs": {
        "title": "Total Programs",
        "description": "Enter the total amount your organization spends annually on program services. This can often be found on IRS form 990.",
        "title_2": "Add Individual Programs",
        "description_2": "Add details for each individual program your organization runs.",
        "individual_title": "Total expense programs",
        "add_title": "Add Program or Grant",
        "info": "Programs are organized activities or services offered to fulfill the organization's mission and serve the public good. These programs are designed to address specific community needs and are typically funded through donations and fundraising efforts.",
        "add_another": "Add another Program or Grant",
        "totalGrantsPrograms_label": "Total Programs",
        "totalGrantsPrograms_placeholder": "Enter total programs",
        "name_label": "Program Name",
        "name_sublabel": "Enter the name of the specific program",
        "name_placeholder": "Add a program name",
        "budget_label": "Annual Program Expense",
        "budget_sublabel": "Enter the total amount of funds your organization spent annually on this program or activity.",
        "budget_placeholder": "Add annual program expense",
        "submit_and_add": "Submit and add another Program or Grant"
      },
      "light_rating_questions": {
        "title": "Questions",
        "info": "Questions to add transparency",
        "no_questions": "There was an error loading the questions"
      }
    },
    "location": {
      "title": "Turn on Location?",
      "description": "Share your location to find non-profits and volunteer events near you.",
      "button": "Yes, grant location"
    },
    "notification": {
      "title": "Turn on Notifications",
      "description": "Stay informed with real-time alerts about volunteer sign-ups, important updates and donation activity.",
      "button": "Yes, notify me"
    }
  },
  "sign_up": {
    "nonProfit": {
      "wizard": {
        "errors": {
          "focusAreasLimit": "Selection limit reached. You may only choose up to 5 focus areas.",
          "nineNintyRequested": "990 form is required",
          "general": {
            "nameRequested": "Your Non-Profit Org name is required",
            "address": "Address of Organization is required",
            "numberEmployeesNumber": "Numbers only—no letters or symbols",
            "numberEmployeesRequested": "Number of Employees is required",
            "numberVolunteersNumber": "Numbers only—no letters or symbols",
            "numberVolunteersRequested": "Number of Volunteers is required.",
            "minThumbsRequested": "Enter at least the Main image"
          },
          "revenueNumber": "Numbers only—no letters or symbols",
          "revenueRequested": "Total Annual Revenue is required",
          "expensesNumber": "Numbers only—no letters or symbols",
          "expensesRequested": "Total Annual Expenses is required",
          "background": {
            "employeesRequested": "Yes or No selection is required",
            "volunteersRequested": "Yes or No selection is required"
          },
          "pastor": {
            "titleRequested": "Title is required",
            "jobRequested": "Job Title is required",
            "jobNumber": "Numbers only - no letters or symbols",
            "jobNumberNotZero": "Should be more than 0",
            "salaryRequested": "Annual Salary is required",
            "pastorRequested": "Please enter at least 1 Pastor",
            "stipendRequested": "Stipend is required",
            "stipendNumber": "Numbers only - no letters or symbols"
          },
          "boardDirector": {
            "titleRequested": "Name is required",
            "jobRequested": "Job Title is required",
            "jobNumber": "Numbers only - no letters or symbols",
            "jobNumberNotZero": "Should be more than 0",
            "salaryRequested": "Annual Salary is required",
            "boardRequested": "Please enter at least 1 Director",
            "stipendRequested": "Stipend is required",
            "stipendNumber": "Numbers only - no letters or symbols"
          },
          "totalSalaries": {
            "mustBeNumber": "Numbers only - no letters or symbols",
            "requested": "Total annual salary is required."
          },
          "benefits": {
            "mustBeNumber": "Numbers only - no letters or symbols",
            "requested": "Total annual employee benefits is required."
          },
          "plRequested": "P & L statement is required",
          "balanceSheetRequested": "Balance Sheet is required",
          "thirdPartyAudit": "Yes or No selection is required",
          "thirdPartyAuditRequired": "3rd Party Audit file is required",
          "impactStudy": "Yes or No selection is required",
          "impactStudyRequired": "Impact Study file is required",
          "salaries": {
            "nameRequested": "Name is required",
            "jobTitle": "Job Title is required",
            "annualNumber": "Annual Salary must be a number",
            "annualRequested": "Annual Salary is required",
            "housingNumber": "Housing Allowance must be a number",
            "housingRequested": "Housing Allowance is required",
            "minimal": "Please enter at least %{minimal_salaries} Salaries",
            "max": "Please enter less than 10 Salaries"
          },
          "totalLand": {
            "mustBeNumber": "Numbers only—no letters or symbols",
            "requested": "Annual Cost for Land, Buildings and Equipment is required."
          },
          "totalFundraising": {
            "mustBeNumber": "Numbers only—no letters or symbols",
            "requested": "Annual Cost for Fundraising and Marketing is required. "
          },
          "programs": {
            "name": "Name is required",
            "description": "Description is required",
            "mustBeNumber": "Must be a number",
            "annualBudget": "Annual Budget is required",
            "minimal": "Please enter at least 1 Program"
          },
          "totalGrantsPrograms": {
            "totalGrants": "Total Grants is required",
            "name": "Name is required",
            "amountSpent": "Amount Spent is required",
            "mustBeNumber": "Must be a number",
            "minimal": "Please enter at least 1 Program"
          }
        }
      }
    }
  },
  "end_flow": {
    "error_title": "Oops!",
    "error_message": "There was an error. Please try again later.",
    "success_title": "Success!"
  },
  "register_modal": {
    "title": "Access Restricted",
    "subtitle": "You need an account to access this section. Please sign in to proceed.",
    "button_label": "Proceed",
    "ai_search_subtitle": "You need an account to access AI Powered Search"
  },
  "maintenance_modal": {
    "title": "System Maintenance",
    "description": "The application is temporarily unavailable due to maintenance. Service will resume shortly."
  },
  "mission_detail": {
    "supporting_charities": "Supporting Charities"
  },
  "question": {
    "question_list": {
      "question": "Question:",
      "answer": "Answer:"
    },
    "ask": {
      "comment_placeholder": "Write your question",
      "email_placeholder": "Enter email address",
      "success_title": "Question sent",
      "success_message": "Your question has been sent successfully."
    },
    "add": {
      "title": "Add Q and A",
      "question_label": "Add question",
      "question_placeholder": "Enter question",
      "ask_label": "Add answer",
      "ask_placeholder": "Enter answer",
      "success_message": "Question and answer added successfully"
    }
  },
  "program_detail": {
    "annual_budget": "Annual budget",
    "program_director": "Program Director",
    "write_message_placeholder": "Write message",
    "enter_your_email_placeholder": "Enter your email"
  },
  "volunteer_detail": {
    "confirmed": "You are now confirmed",
    "add_to_calendar": "Add to calendar",
    "you_must_register_title": "Registration Required",
    "you_must_register_message": "You need to register before signing up for a volunteer event.",
    "register_now": "Register Now",
    "event_created": "Event created!",
    "event_creation_success": "Event %{event_name} created successfully.",
    "event_creation_fail": "Error creating event",
    "event_signup_fail": "Error Signing Up"
  },
  "trending_detail": {
    "npos_area": "Non-profits in this affected area",
    "empty_charities": "No charities to show"
  },
  "donation": {
    "donate": "Donate",
    "donation_amount": "Donation Amount",
    "footer_subtitle": "100% of donations go to non-profit",
    "your_support": "Your support changes lives",
    "choose_where": "Choose where to donate",
    "gift_types": "Gift Types",
    "date": "Start Donation On",
    "monthly_updates": "Opt in for monthly updates",
    "opt_out_updates": "Opt out for updates",
    "donate_icac": "Donate to ICAC",
    "donate_organization": "Donate to Organization",
    "icac_info_title": "ICAC Donation",
    "icac_info_subtitle": "The Internet Crimes Against Children (ICAC) Task Force Program is a national network of coordinated task forces that help state and local law enforcement agencies develop an effective response to technology-facilitated child sexual exploitation and Internet crimes against children.",
    "icac_organization_info_title": "Support Organization",
    "icac_organization_info_subtitle": "This contribution supports the organization's general operations and is distinct from the ICAC Task Force Program.",
    "icac_subtitle": "Search state by state for your local ICAC",
    "select_state": "Select State",
    "state_placeholder": "Select a US state",
    "success_message": "Donated %{AMOUNT} to %{WHERE}",
    "subscription_success_message": "Your %{FREQUENCY} donation of %{AMOUNT} to %{WHERE} will begin on %{DATE}.",
    "contribute_fee_label": "Add 2.5% to contribute to processing costs",
    "error_title": "You can't donate",
    "error_message": "Donations are not available for Broken Shepherds™ or for users with a Non-Profit Organization account.",
    "empty_amount": "A donation of $0 is not allowed. Please enter a valid amount.",
    "confirm_payment_title": "Confirm Payment",
    "edit_subscription_title": "Edit Subscription",
    "select_payment_method": "Select Payment Method",
    "recurring_option": "Recurring option: ",
    "subscription_edited": "Subscription edited successfully",
    "subscription_deleted": "Subscription canceled successfully",
    "subscription_billing_period": "Billing Period: %{PERIOD}LY",
    "subscription_start_date": "Start Date: %{DATE}",
    "subscription_next_due_date": "Next Due Date: %{DATE}",
    "subscription_empty_list": "No subscriptions made yet",
    "amount_required": "Amount is required",
    "where_required": "Where to donate is required",
    "state_required": "State is required",
    "start_date_required": "Start Date is required",
    "due_date_required": "Due Date is required",
    "refund": "Refund",
    "refund_transaction": "Refund Transaction",
    "cancel_transaction": "Cancel Transaction",
    "refund_confirm_message": "Are you sure you want to proceed with the refund? The amount will be returned, and this cannot be undone.",
    "cancel_confirm_message": "Are you sure you want to cancel this payment? This action cannot be undone.",
    "cancel_period_expired": "Cancel Period Expired",
    "cancel_period_message": "The transaction cancel period expired, contact your NPO to ask for a refund",
    "subscription_cancel_confirm_message": "Are you sure you want to cancel your recurring donation? This action cannot be undone.",
    "transaction_canceled": "Transaction canceled successfully",
    "transaction_refund": "Transaction refunded successfully",
    "transaction_fee": "Transaction fee: $%{FEE}",
    "npo_contributed_transaction_fee": "Contributed additional 2.5% towards the processing fee.",
    "status": "Status",
    "payment_method": "Payment Method",
    "payment_method_ach": "Bank Transfer (ACH)",
    "payment_method_card": "Credit Card",
    "payment_code": "Enter the Verification Code",
    "notes": "Notes: %{NOTES}"
  },
  "claim_npo": {
    "to_claim": "To claim this as your non-profit organization, enter your phone number and email address.",
    "contact_you": "We will contact you to verify within 24-48 hours.",
    "claim_form_title": "Claiming your non-profit %{NPO_NAME} starts now",
    "claim_form_subtitle": "Let's get your organization verified so you can take control of your public profile and share your mission with the world.",
    "secured_data": "Your information is transmitted securely and kept confidential.",
    "claim_success_title": "You're all set!",
    "claim_success_message": "You have been verified successfully. We'll reach out within 48 hours to guide you through the next steps.",
    "no_results": "There are no results with that organization name. Please try again.",
    "error_contact_us": "If you believe there is an error, please contact us.",
    "browse_bs": "Browse Broken Shepherds™",
    "info_submitted": "Thank you for sending your information!",
    "browse_bs_meanwhile": "You may continue to browse Broken Shepherds™ during the review process.",
    "find_your_npo": "Let's find your organization",
    "search_your_npo": "Enter your organization name and tap search",
    "search_npo_placeholder": "Enter organization name here",
    "contact_bs": "Contact Broken Shepherds™",
    "this_npo": "Claim this Non-Profit",
    "confirm_title": "Is %{NPO_NAME} your non-profit organization?",
    "benefits_header": "Claim it to:",
    "benefits_message": "Customize your profile\nBoost your visibility and donor group\nGet a verified badge",
    "claim_button_label": "Claim %{NPO_NAME} Now",
    "firstName_label": "Your first name",
    "firstName_placeholder": "Enter your first name",
    "required_firstName": "Your first name is required",
    "lastName_label": "Your last name",
    "lastName_placeholder": "Enter your last name",
    "required_lastName": "Your last name is required",
    "npoName_label": "Name of non-profit",
    "npoName_placeholder": "Enter name of non-profit",
    "required_npoName": "Name of non-profit is required",
    "email_label": "Your email address",
    "email_placeholder": "Enter your email address",
    "required_email": "Your email address is required",
    "phone_label": "Your phone number",
    "phone_placeholder": "Enter your phone number",
    "required_phone": "Your phone number is required",
    "driverLicense_label": "Upload Driver License",
    "required_driverLicense": "Driver License is required",
    "articlesOfIncorporation_label": "Upload Articles of Incorporation",
    "required_articlesOfIncorporation": "Articles of Incorporation is required"
  },
  "favorites": {
    "failure_message": "Error updating favorites.",
    "empty_favorites": "No favorites to show"
  },
  "credit_cards": {
    "add": "Add Credit Card",
    "holder_label": "CARD HOLDER",
    "number_label": "CARD NUMBER",
    "number_invalid": "Number is invalid",
    "expiry_label": "EXPIRATION",
    "expiry_invalid": "Expiration date is invalid",
    "cvc_label": "CVC/CVV",
    "cvc_invalid": "CVC is invalid",
    "finished_in": "Finished in %{NUMBER}",
    "expiry": "Expiration: %{EXPIRY}",
    "saved_empty": "No credit cards saved"
  },
  "npoPaymentOnboarding": {
    "api_error": "Something went wrong while processing your request.\n- API detail: %{ERROR_DETAIL}\n\nPlease try again or contact support if the issue persists.",
    "title": {
      "intro": "Unlock the power of giving!",
      "cardTerms": "Card - Terms of Service",
      "achTerms": "ACH - Terms of Service",
      "completeCompany": "Complete Company",
      "completeOwner": "Complete Owner",
      "completeRiskProfile": "Complete Risk Profile",
      "completeBankAccount": "Complete Bank Account",
      "completeDocuments": "Complete Documents"
    },
    "intro": {
      "subtitle": "Discover a new world of donors on Broken Shepherds™.  Have these details and documents and you're ready to roll!",
      "what_you_will_need": "What you will need",
      "button_label": "Start Application",
      "list": {
        "ein": "EIN",
        "startDate": "Start Date of Organization",
        "customerServicePhone": "Customer Service Phone Number",
        "address": "Organization Address",
        "website": "Website",
        "ownerSSN": "Account Owner Social Security Number",
        "voidedCheck": "Voided Check or Signed Bank Letter document",
        "driversLicense": "Driver's License of Owner or Signer document",
        "certificationDocument": "501(c)(3) Certification (990, IRS determination letter) document",
        "articlesOfIncorporation": "Articles of Incorporation document",
        "bankStatements": "Bank Statements document"
      }
    },
    "terms_cc": "View Credit Card Terms of Services",
    "terms_ach": "View ACH Terms of Services",
    "terms_readed": "I acknowledge that I have read and understood the terms and conditions.",
    "accept_continue": "Accept and Continue",
    "need_help": "Need help with payments?",
    "submit_label": "Submit for Review",
    "try_again": "Something went wrong while creating your account. Please submit again or contact support if the issue persists.",
    "success_message": "Account submitted for review",
    "documents_updated": "Documents updated and submitted for review",
    "general_form": {
      "companyLegalName_label": "Legal Name",
      "companyLegalName_placeholder": "Enter legal name",
      "companyLegalName_required": "Required legal name",
      "companyDbaName_label": "DBA Name",
      "companyDbaName_placeholder": "Enter DBA name",
      "companyDbaName_required": "Required DBA name",
      "companyOwnershipType_label": "Ownership Type",
      "companyOwnershipType_placeholder": "Select ownership type",
      "companyOwnershipType_valid_type": "Must be a valid type",
      "companyOwnershipType_required": "Required ownership type",
      "organizationCategory_label": "Organization category",
      "organizationCategory_label_placeholder": "Select organization category",
      "organizationCategory_label_valid_type": "Must be a valid type",
      "organizationCategory_label_required": "Required organization category",
      "companyFederalTaxId_label": "EIN Number",
      "companyFederalTaxId_placeholder": "Enter EIN Number",
      "companyFederalTaxId_required": "Required EIN Number",
      "companyFederalTaxId_only_numbers": "Must contain only digits and no dashes",
      "companyUrl_label": "Company Website",
      "companyUrl_placeholder": "Enter company website URL",
      "companyUrl_required": "Required company website URL",
      "companyMcc_label": "MCC Code",
      "companyMcc_placeholder": "5999",
      "companyMcc_required": "Required MCC Code",
      "customerSupportNumber_label": "Customer Support Number",
      "customerSupportNumber_placeholder": "Enter customer support number",
      "customerSupportNumber_required": "Required customer support number",
      "companyPhoneNumber_label": "Company Phone Number",
      "companyPhoneNumber_placeholder": "Enter company phone number",
      "companyPhoneNumber_required": "Required company phone number",
      "legalAddress_label": "Legal Address",
      "legalAddress_placeholder": "Enter legal address",
      "legalAddress_required": "Required Legal Address",
      "dbaAddress_label": "DBA Address",
      "dbaAddress_placeholder": "Enter DBA address",
      "dbaAddress_required": "Required DBA Address"
    },
    "owner_form": {
      "firstName_label": "First Name",
      "firstName_placeholder": "Enter First Name",
      "firstName_required": "Required First Name",
      "middleName_label": "Middle Name",
      "middleName_placeholder": "Enter Middle Name",
      "lastName_label": "Last Name",
      "lastName_placeholder": "Enter Last Name",
      "lastName_required": "Required Last Name",
      "emailAddress_label": "Email Address",
      "emailAddress_placeholder": "Enter Email Address",
      "emailAddress_required": "Required Email Address",
      "emailAddress_no_plus": "No plus signed allowed",
      "phone_label": "Phone Number",
      "phone_placeholder": "Enter Phone Number",
      "phone_required": "Required Phone Number",
      "dateOfBirth_label": "Date of Birth",
      "dateOfBirth_placeholder": "Enter Date of Birth",
      "dateOfBirth_required": "Required Date of Birth",
      "dateOfBirth_invalid_age": "Must be 18 years or older",
      "socialSecurityNumber_label": "Social Security Number",
      "socialSecurityNumber_placeholder": "Enter Social Security Number",
      "socialSecurityNumber_required": "Required Social Security Number",
      "driversLicenseNumber_label": "Driver's License Number",
      "driversLicenseNumber_placeholder": "Enter Driver's License Number",
      "driversLicenseNumber_required": "Required Driver's License Number",
      "address_label": "Address",
      "address_placeholder": "Enter address",
      "address_required": "Required Address",
      "signingManager_label": "Signing Manager",
      "signingManager_placeholder": "Enter Signing Manager's",
      "signingManager_required": "Required Signing Manager's",
      "signingManager_force_true": "Please confirm the Signing Manager by checking the box"
    },
    "risk_profile_form": {
      "averageTransactionAmount_label": "Average Transaction Amount",
      "averageTransactionAmount_placeholder": "Enter average transaction amount",
      "averageTransactionAmount_info": "Average credit card dollar amount your organization expects to receive for a single donation.",
      "averageTransactionAmount_required": "Enter average transaction amount",
      "highestTicket_label": "Highest Ticket",
      "highestTicket_placeholder": "Enter highest ticket amount",
      "highestTicket_info": "Largest credit card dollar amount your organization expects to receive for a single donation.",
      "highestTicket_required": "Required highest ticket amount",
      "monthlyProcessingVolume_label": "Monthly Processing Volume",
      "monthlyProcessingVolume_placeholder": "Enter monthly processing volume",
      "monthlyProcessingVolume_info": "Total credit card dollars your organization expects to receive in a month.",
      "monthlyProcessingVolume_required": "Required monthly processing volume",
      "averageCheckAmount_label": "Average Check Amount",
      "averageCheckAmount_placeholder": "Enter average check amount",
      "averageCheckAmount_info": "Average check dollar amount your organization expects to receive for a single donation.",
      "averageCheckAmount_required": "Required average check amount",
      "maximumCheckAchAmount_label": "Maximum ACH Amount",
      "maximumCheckAchAmount_placeholder": "Enter maximum check ACH amount",
      "maximumCheckAchAmount_info": "Largest ACH dollar amount your organization expects to receive for a single donation.",
      "maximumCheckAchAmount_required": "Required maximum check ACH amount",
      "averageNumberOfChecksPerMonth_label": "Average Number of Checks Per Month",
      "averageNumberOfChecksPerMonth_placeholder": "Enter average number of checks per month",
      "averageNumberOfChecksPerMonth_info": "Average number of checks your organization expects to receive per month.",
      "averageNumberOfChecksPerMonth_required": "Required average number of checks per month",
      "monthlyCheckVolume_label": "Monthly Check Volume",
      "monthlyCheckVolume_placeholder": "Enter monthly check volume",
      "monthlyCheckVolume_info": "Total check dollars your organization expects to receive in a month.",
      "monthlyCheckVolume_required": "Required monthly check volume",
      "businessStartDate_label": "Business Start Date",
      "businessStartDate_placeholder": "Enter business start date",
      "businessStartDate_info": "Date of incorporation.",
      "businessStartDate_required": "Required business start date"
    },
    "bank_account_form": {
      "bankRoutingNumber_label": "Bank Routing Number",
      "bankRoutingNumber_placeholder": "Enter bank routing number",
      "bankAccountNumber_label": "Bank Account Number",
      "bankAccountNumber_placeholder": "Enter bank account number"
    },
    "documents_form": {
      "voidedcheck_label": "Voided Check or Signed Bank Letter",
      "voidedcheck_required": "A voided check or signed bank letter is required.",
      "driverLicense_label": "Driver's License of Owner or Signer",
      "driverLicense_required": "A valid driver's license of the owner or signer is required.",
      "doc501c3_label": "501(c)(3) Certification Document",
      "doc501c3_required": "A valid 501(c)(3) certification document is required.",
      "articlesOfIncorporation_label": "Articles of Incorporation",
      "bankStatements_label": "Bank Statements",
      "bankStatements_helper": "A statement from within the last month is acceptable.",
      "helper_text": "Accepted file types are PDF, WORD, EXCEL, CSV, JPEG, PNG and ZIP. The maximum file size is %{MAX_FILE_SIZE} MB."
    }
  },
  "payment_methods": {
    "billing_address_label": "BILLING ADDRESS",
    "billing_address_placeholder": "Enter Billing Address",
    "account_only_digits": "Must contain only digits",
    "account_min_length": "Min length 4 digits",
    "account_max_length": "Max length 17 digits",
    "invalid_address": "Invalid Address",
    "ach": "ACH",
    "ach_added": "ACH Account added succesfully!",
    "ach_delete_confirm": "Are you sure you want to delete this ACH Account?",
    "ach_deleted": "ACH Account Deleted Succesfully!",
    "ach_delete_error": "Error deleting ACH account",
    "ach_empty_list": "No ACH accounts saved",
    "add_ach": "Add ACH account",
    "account_type": "Account Type",
    "ach_checking": "Checking",
    "ach_saving": "Saving",
    "ach_personal": "Personal",
    "ach_business": "Business",
    "ach_name_label": "Name on Account",
    "ach_name_placeholder": "Enter Name on Account",
    "ach_name_required": "Required Name on Account",
    "ach_account_number_label": "Account Number",
    "ach_account_number_placeholder": "Enter Account Number",
    "ach_account_number_required": "Required Account Number",
    "ach_routing_number_label": "Routing Number",
    "ach_routing_number_placeholder": "Enter Routing Number",
    "ach_routing_number_required": "Required Routing Number",
    "ach_routing_number_invalid": "We couldn't verify this Routing Number. Please check that it's correct and belongs to a valid financial institution.",
    "ach_required_account_type": "Required account type",
    "card": "Credit/Debit Card",
    "card_added": "Card added succesfully!",
    "card_delete_confirm": "Are you sure you want to delete this Card?",
    "card_deleted": "Card Deleted Succesfully!",
    "card_delete_error": "Error deleting Card"
  },
  "donation_options": {
    "one_time": "Give One Time",
    "recurring": "Recurring",
    "week": "Weekly",
    "month": "Monthly",
    "year": "Yearly"
  },
  "donation_summary": {
    "title": "Donation Summary",
    "supporting": "Supporting: %{WHERE}",
    "amount": "Amount: %{AMOUNT}",
    "type": "Type: %{TYPE}",
    "frequency": "Frequency: %{FREQUENCY}LY",
    "payment_method": "Payment Method",
    "api_error": "Something went wrong while processing your request.\n- Payment API detail: %{ERROR_DETAIL}\n\nPlease try again or contact support if the issue persists."
  },
  "billing_address": {
    "name_label": "First Name",
    "name_placeholder": "Enter First Name",
    "name_required": "Required First Name",
    "name_validation": "First Name can only include A-Z, a-z, 0-9, space, and (. , ' & -)",
    "surname_label": "Last Name",
    "surname_placeholder": "Enter Last Name",
    "surname_required": "Required Last Name",
    "surname_validation": "Last Name can only include A-Z, a-z, 0-9, space, and (. , ' & -)",
    "address_label": "Address",
    "address_placeholder": "Enter Address",
    "address_required": "Required Address",
    "email_label": "Email",
    "email_placeholder": "Enter Email",
    "email_confirmation_label": "Email Confirmation",
    "email_confirmation_placeholder": "Enter Email Confirmation"
  },
  "auth": {
    "name_required": "Name is required",
    "last_name_required": "Last Name is required",
    "pw_required": "Password is required",
    "min_numbers": "Include 1 number",
    "min_lowercase": "Must contain at least one lowercase",
    "min_uppercase": "Must contain at least one uppercase",
    "min_interests": "At least one checkbox has to be selected"
  },
  "faq": {
    "what_is_broken_shepherds": {
      "question": "What is Broken Shepherds™?",
      "answer": "Broken Shepherds™ strives to facilitate open communication and foster transparency between churches/non-profits, donors, and volunteers by providing a transformative platform that helps donors and volunteers make informed decisions about where to invest their time and money."
    },
    "what_is_light_rating": {
      "question": "What is a Light Rating?",
      "answer": "A Light Rating is a score given based on data and documents provided by each non-profit organization. The rating is calculated using a proprietary standardized formula. Broken Shepherds™ takes an unbiased stance regarding data provided."
    },
    "can_broken_shepherds_adjust_ratings": {
      "question": "Can Broken Shepherds™ manually adjust the Light Ratings?",
      "answer": "No. Broken Shepherds™ uses a proprietary standardized formula to calculate all Light Ratings, based solely on the data and documents provided by each non-profit organization. There are no manual adjustments and each organization's Light Rating is not impacted by another."
    },
    "who_can_claim_nonprofit": {
      "question": "Who can edit a non-profit organization?",
      "answer": "An individual, with a full active profile, may edit portions of an unclaimed non-profit account. This data does not affect the Light Rating. A representative from the organization may claim the non-profit account and complete the verification process. Once they have been verified, the Light Rating is activated and the non-profit may complete their account profile."
    },
    "does_bs_receive_donation": {
      "question": "Does Broken Shepherd receive any portion of a donation?",
      "answer": "No. Broken Shepherd does not receive any portion of the donations made to non-profit organizations through the platform. The non-profit organizations receive 100% of the donations made to them."
    },
    "does_bs_charge_donation": {
      "question": "Does it cost anything to donate through Broken Shepherds™?",
      "answer": "While Broken Shepherds™ does not charge donors directly, payment processing fees may apply. These fees are set by the payment processor and can vary depending on the payment method used."
    },
    "does_bs_store_info": {
      "question": "Does Broken Shepherds™ store any credit card and/or banking information?",
      "answer": "Broken Shepherd does not store any credit card and/or details. Payment details, including credit card and banking information, are stored with the payment processor partner, Nuvei. Nuvei is PCI DSS Level 1 compliant. This means they meet the highest standards of security for processing and handling sensitive cardholder data, as defined by the Payment Card Industry Data Security Standard."
    }
  },
  "trb_show": {
    "sign_in_to_buy": "Experience 'The Religion Business' docuseries with a special app-only discount — sign in to buy now.",
    "about_to_purchase": "You're about to purchase",
    "about_to_gift": "You're about to gift",
    "purchase": "Purchase",
    "confirm_purchase": "Confirm Purchase",
    "purchase_succes_title": "Purchase Successful!",
    "purchase_succes_message": "Your purchase is complete. Get ready to dive into The Religion Business",
    "number_episodes": "2025 %{LENGTH} episodes",
    "play": "Play",
    "continue_watching": "Continue Watching",
    "watch_trailer": "Watch the trailer now!",
    "normal_price": "Price: $%{PRICE}",
    "normal_price_per_show": "Normal Cost Per Show: $%{PRICE}",
    "special_price": "Discount Price: $%{PRICE}",
    "special_price_per_show": "Your Cost: $%{PRICE}",
    "release_date": "Release Date: %{DATE}",
    "share_title": "Check out The Religion Business!",
    "share_description": "A powerful docuseries exposing hidden abuse, fraud, and corruption in the non-profit sector—where good intentions mask dark realities.",
    "gifted_share_title": "You've been gifted *The Religion Business*!",
    "gifted_share_description": "Watch this powerful docuseries uncovering abuse, fraud, and corruption in the non-profit sector—now available to you for free thanks to a gift.",
    "gifted_sms_message": "Hey, I have gifted you “The Religion Business” docuseries! All you have to do is tap the link below and log in with your phone number. https://www.thereligionbusiness.com/login \n\nCan't wait to hear what you think of it!  It's a game-changer.",
    "taxes_included": "Taxes included"
  },
  "manual_address": {
    "address1_label": "Street Address",
    "address1_placeholder": "Enter Street Address",
    "address1_required": "Street Address is required",
    "city_label": "City",
    "city_placeholder": "Enter City",
    "city_required": "City is required",
    "city_validation": "City can only include letters, numbers, spaces, and (. , ' & -)",
    "region_label": "State",
    "region_placeholder": "Enter State",
    "region_required": "State is required",
    "region_validation": "State must be a 2-letter code (e.g., NY, CA)",
    "postalCode_label": "ZIP Code",
    "postalCode_placeholder": "Enter ZIP Code",
    "postalCode_required": "ZIP Code is required",
    "postalCode_validation": "ZIP Code must be 5 digits",
    "country_label": "Country",
    "country_placeholder": "Enter Country",
    "country_required": "Country is required",
    "country_validation": "Country can only include letters, spaces, and dots"
  },
  "giftShows": {
    "firstName_label": "First Name",
    "firstName_required": "First Name is required",
    "lastName_label": "Last Name",
    "lastName_required": "Last Name is required",
    "max_gifts": "You cannot gift more than 10 shows simultanously",
    "min_gifts": "At least 1 gift need to be made",
    "gifts_empty_list": "No gifts made yet",
    "add_one": "+ Add a Gift",
    "add_another": "+ Add Another Gift",
    "phone_already_on_list": "Phone is already on the list",
    "header_subtitle": "Share the series with family, friends, or colleagues by entering their name and phone number. You can add up to 10 recipients. Once you've added everyone, click “Go to Checkout” to complete your purchase.",
    "total_cost_prefix": "Total Cost:",
    "total_cost_middle": "shows",
    "go_to_checkout": "Go To Checkout",
    "gifted_on": "You gifted this on:",
    "to": "To:",
    "total_cost": "Total Cost:",
    "gift_series_title": "Gift 'The Religion Business' Series",
    "gifted_copy_url": "Go to this link and enter your phone number to view the docuseries for free! https://www.thereligionbusiness.com/login",
    "review_confirm_title": "Review and Confirm Purchase",
    "success_title": "Gifts sent successfully!",
    "success_message": "Thanks for sharing The Religion Business — they will love it!",
    "summary_subtitle": "Here are your recipients. Tap “Text User” to send the show link directly, or copy the URL to share it however you prefer.",
    "duplicatePhones_title": "Some phones already have access",
    "duplicatePhones_message": "The following phone numbers already own the series:\n%{PHONES}\n\nYou can remove them and continue sending gifts to the others.",
    "duplicatePhones_buttonLabel": "Remove these phones",
    "noRemainingPhones_title": "All phones already have access",
    "noRemainingPhones_message": "All selected phone numbers already own the series. Please go back and update your gift list."
  },
  "verifyCode": {
    "required": "The Verification Code is Required",
    "description": "To complete verification, enter the code we just sent to your email address.",
    "label": "Verification Code",
    "placeholder": "Enter the Verification Code"
  },
  "wikiChangeNpoModal": {
    "title": "Help Us Contact This Church",
    "description": "This information is crucial to help us contact your church to bring transparency into the system",
    "success": "Thank you. We'll use this contact information to reach the church and help them claim their profile.",
    "email_label": "Church email address",
    "email_placeholder": "Enter church email address",
    "phone_label": "Church phone number",
    "phone_placeholder": "Enter church phone number"
  }
}